import React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

interface MultipleSelectCheckmarksProps {
  label: string;
  options: string[];
  selectedValues: string;
  onChange: (selected: string) => void;
  width?: number;
  inputLabelStyle?: object;
  selectInputStyle?: object;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const MultipleSelectCheckmarks: React.FC<MultipleSelectCheckmarksProps> = ({
  label,
  options,
  selectedValues, // Change this to selectedValue
  onChange,
  width = 300,
  inputLabelStyle = {},
  selectInputStyle = {}
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    // Change type to string
    const value = event.target.value;
    onChange(value ? value : "");
  };

  return (
    <FormControl sx={{ width }}>
      <InputLabel sx={inputLabelStyle}>{label}</InputLabel>
      <Select
        value={selectedValues || ""}
        onChange={handleChange}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected || ""}
        MenuProps={MenuProps}
        sx={selectInputStyle}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {/* <Checkbox checked={selectedValues.includes(option)} /> */}
            <ListItemText primary={option} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleSelectCheckmarks;
